import { render, staticRenderFns } from "./ThreeColumnsBanner.vue?vue&type=template&id=3c033d0b&"
import script from "./ThreeColumnsBanner.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports